import { __decorate } from "tslib";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ApplicationCreateService } from "../application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { Subject } from "rxjs";
import { AutoUnsub } from "../../../../shared/decorators/autounsub.decorator";
let CreateApplicationViewBaseComponent = class CreateApplicationViewBaseComponent {
    createApplicationService;
    aflaModuleStrategyService;
    _destroy$ = new Subject();
    stepMeta;
    startMetadataSubscription;
    constructor(createApplicationService, aflaModuleStrategyService) {
        this.createApplicationService = createApplicationService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
    }
    getMetadata() {
        this.startMetadataSubscription = this.createApplicationService.$startMetadata.subscribe(stepMeta => {
            if (stepMeta != null) {
                this.stepMeta = stepMeta;
                this.loadMetadata(this.stepMeta);
            }
        });
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService }
    ];
};
CreateApplicationViewBaseComponent = __decorate([
    Component({
        standalone: false,
        template: "",
        changeDetection: ChangeDetectionStrategy.OnPush
    }),
    AutoUnsub()
], CreateApplicationViewBaseComponent);
export { CreateApplicationViewBaseComponent };
